import { Bell } from 'lucide-react'
import { Button } from '@atrvd/saas-ui'
import { OrganizationSwitcher } from './OrganizationSwitcher'
import { UserMenu } from './UserMenu'

/**
 * Top navigation bar component
 * Full-width bar with organization selector on left and user controls on right
 * Layout: [OrgSwitcher] ---------- [Bell] [UserMenu]
 */
export function TopBar() {
  return (
    <header className="flex-shrink-0 z-40 flex h-16 items-center justify-between border-b bg-card px-6">
      {/* Left side: Organization Switcher */}
      <div className="flex items-center">
        <OrganizationSwitcher />
      </div>

      {/* Right side: Actions */}
      <div className="flex items-center gap-2">
        {/* Notifications bell */}
        <Button variant="ghost" size="icon" className="relative" aria-label="Notifications">
          <Bell className="h-5 w-5" />
        </Button>

        {/* User menu */}
        <UserMenu />
      </div>
    </header>
  )
}